export const DragItemTypes = {
  QUERY: 'query',
  COLLECTION: 'collection',
  FOLDER: 'folder',
  EDITOR_TAB: 'editor_tab',
} as const;

export type DragItemType = typeof DragItemTypes[keyof typeof DragItemTypes];

export interface QueryDragItem {
  type: typeof DragItemTypes.QUERY;
  id: string;
  name: string;
  collectionId: string;
  folderId?: string;
  orderIndex?: number;
}

export interface CollectionDragItem {
  type: typeof DragItemTypes.COLLECTION;
  id: string;
  name: string;
  description?: string;
}

export interface FolderDragItem {
  type: typeof DragItemTypes.FOLDER;
  id: string;
  name: string;
  description?: string;
  collectionId: string;
  parentFolderId?: string;
}

export interface EditorTabDragItem {
  type: typeof DragItemTypes.EDITOR_TAB;
  id: string;
  label: string;
  content: string;
  isDirty?: boolean;
  savedQueryId?: string;
  savedQueryCollectionId?: string;
  savedQueryName?: string;
  datasourceId?: string;
  databaseName?: string;
  schemaName?: string;
}

export type DragItem = QueryDragItem | CollectionDragItem | FolderDragItem | EditorTabDragItem;

export interface DropTarget {
  type: 'collection' | 'folder';
  id: string;
  collectionId?: string;
  acceptedTypes: DragItemType[];
  name?: string;
}

// Drop result interface for providing feedback
export interface DropResult {
  success: boolean;
  message?: string;
  targetType: 'collection' | 'folder';
  targetId: string;
  targetName?: string;
}

